import { styled } from 'goober';

export const Member = styled('div')`
    display: flex;

    &:not(:last-child) {
        margin-bottom: 12px;
    }
`;

export const MemberAmount = styled('div')`
    display: flex;
    align-items: center;
    margin-left: auto;

    span {
        margin-left: 12px;
    }
`;

export const MemberText = styled('div')`
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 4px;
    margin-left: 16px;
`;
